import { render, staticRenderFns } from "./AiLayout.vue?vue&type=template&id=02fcf15b&scoped=true"
import script from "./AiLayout.vue?vue&type=script&lang=js"
export * from "./AiLayout.vue?vue&type=script&lang=js"
import style0 from "./AiLayout.vue?vue&type=style&index=0&id=02fcf15b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fcf15b",
  null
  
)

export default component.exports